import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { CounterpartyTypeDto } from '@/modules/counterparty/dto/counterparty-type.dto.ts';
import type { CounterpartyType } from '@/modules/counterparty/types/counterparty-type.type.ts';

export class CounterpartyTypeAdapter {
  private static map(response: CounterpartyTypeDto): CounterpartyType {
    return {
      id: response.TYPE_ID,
      name: response.Название,
    };
  }

  static mapList(response: ItemsDto<CounterpartyTypeDto>) {
    return response.items.map(CounterpartyTypeAdapter.map);
  }
}
